import { render } from "./IVkComment.vue?vue&type=template&id=e70c6bbe"
import script from "./IVkComment.vue?vue&type=script&lang=js"
export * from "./IVkComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__